import { render, staticRenderFns } from "./add-qualification.vue?vue&type=template&id=0d08cc1c&scoped=true&"
import script from "./add-qualification.vue?vue&type=script&lang=js&"
export * from "./add-qualification.vue?vue&type=script&lang=js&"
import style0 from "./add-qualification.vue?vue&type=style&index=0&id=0d08cc1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d08cc1c",
  null
  
)

export default component.exports